import React, { useEffect, useState } from 'react';
import { Table, Button, Space, Popconfirm, message, Typography, Modal } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useGetInclusionsMutation, useCreateInclusionMutation, useDeleteInclusionMutation } from '../redux/services/apiSlice';
import Form from 'antd/es/form';
import Input from 'antd/es/input';

const { Title } = Typography;

const Inclusions = () => {
    const [getInclusions, { data: inclusions, isLoading }] = useGetInclusionsMutation();
    const [createInclusion] = useCreateInclusionMutation();
    const [deleteInclusion] = useDeleteInclusionMutation();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        getInclusions();
    }, [getInclusions]);

    const handleCreate = async (values) => {
        try {
            await createInclusion(values).unwrap();
            message.success('Inclusion created');
            setIsModalVisible(false);
            form.resetFields();
            getInclusions();
        } catch (error) {
            message.error(error.data?.message || 'Error creating inclusion');
        }
    };

    const handleDelete = async (id) => {
        try {
            await deleteInclusion(id).unwrap();
            message.success('Inclusion deleted');
            getInclusions();
        } catch (error) {
            message.error(error.data?.message || 'Error deleting');
        }
    };

    const columns = [
        { title: 'Item', dataIndex: 'item', key: 'item' },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Popconfirm title="Are you sure?" onConfirm={() => handleDelete(record._id)}>
                    <Button type="primary" danger icon={<DeleteOutlined />} size="small" />
                </Popconfirm>
            ),
        }
    ];

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
                <Title level={2}>Tour Inclusions</Title>
                <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsModalVisible(true)}>Create New</Button>
            </div>
            <Table
                dataSource={inclusions}
                columns={columns}
                rowKey="_id"
                loading={isLoading}
            />
            <Modal
                title="Add New Inclusion"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                onOk={() => form.submit()}
            >
                <Form form={form} onFinish={handleCreate} layout="vertical">
                    <Form.Item name="item" label="Inclusion Item" rules={[{ required: true }]}>
                        <Input placeholder="e.g. Flight Tickets" />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default Inclusions;
